var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"label"},[_vm._v("头像")]),_c('div',{staticClass:"avatar"},[_c('a-avatar',{attrs:{"src":_vm.user.header,"size":144}})],1),_c('div',{staticClass:"center"},[_c('FileUpload',{attrs:{"multiple":false},on:{"uploaded":_vm.uploaded}},[_c('a-button',{attrs:{"icon":"upload"}},[_vm._v(" 更换头像")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }